import ShareableLinkNdaSign from './ShareableLinkNdaSign.component';

export default ShareableLinkNdaSign;